export var DEFAULT_MIN_WIDTH = 0;
export var CARD_MIN_WIDTH = 700;
export var OVERLAPPING_CARD_MIN_WIDTH = 700;
export var STRIP_CARD_MIN_WIDTH = 700;
export var STACKED_CARD_MIN_WIDTH = 130;
export var DEFAULT_ROW_SPAN = 1;
export var DEFAULT_COLUMN_SPAN = 1;
export var ROW_GAP = 32;
export var COLUMN_GAP = 32;
export var MOBILE_ROW_GAP = 20;
export var MOBILE_COLUMN_GAP = 20;
//# sourceMappingURL=constants.js.map